// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2ObUg","toggle":"styles-module__toggle___14pBC"};